// @ts-ignore
import { $models, $modelsLoader } from '../../common/$models'
import importDataFromExternal from './importDataFromExternal.vue'
import { dataImportSettings } from './ModelDataImportSettings'

export const useDataImportSettingPage = () => {
  if (!$models.dataImportSettings) {
    $modelsLoader.loadModel(dataImportSettings)
  }
  $core.VueClass.component('ImportDataFromExternal', importDataFromExternal)
  $core.$router.addRoutes([
    {
      path: '/importDataFromExternal/:importType?', // importType is optional param
      component: importDataFromExternal,
    },
  ])
}
